// extracted by css-extract-rspack-plugin
export default {"container":"container_FgjnY","logoWrap":"logo-wrap_Oh6AS","logo":"logo_tpR6a","name":"name_GMhB8","language":"language_mthjO"};